import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';

// Components
import StaticCompanyMap from './StaticCompanyMap';
import DynamicCompanyMap from './DynamicCompanyMap';

// Helpers
import { DEFAULT_DISPLAYED_PINS, OPTION_TYPES_COMPANY } from '../Company';

// styles
import * as styles from './CompanyMap.scss';
import OptionTypeSwitcher from '../OptionTypeSwitcher/OptionTypeSwitcher';

class CompanyMap extends Component {
  constructor(props) {
    super(props);
    const hasPropertiesForSale = !!get(this.props, [OPTION_TYPES_COMPANY.SALE, 'length']);
    const hasPropertiesForRent = !!get(this.props, [OPTION_TYPES_COMPANY.RENT, 'length']);
    const propertiesOnlyForRent = !hasPropertiesForSale && hasPropertiesForRent;

    this.state = {
      hasPropertiesForSale,
      hasPropertiesForRent,
      isDynamicMap: true,
      displayPinsFor: (propertiesOnlyForRent) ? OPTION_TYPES_COMPANY.RENT : DEFAULT_DISPLAYED_PINS
    };
  }

  getPropertiesIdsMap = () => {
    const properties = this.props[this.state.displayPinsFor];
    return properties.reduce((acc, property) => {
      acc[property.id] = { ...property };
      return acc;
    }, {});
  };

  groupPins = () => {
    const properties = this.props[this.state.displayPinsFor];

    if (!properties || !properties.length) return {};

    return groupBy(properties, ({ address: { location: { lat, lon } } }) => `${lat}|${lon}`);
  };

  switchToDynamicMap = () => {
    this.setState({ isDynamicMap: true });
  };

  handleSelectOption = (evt) => {
    evt.preventDefault();
    const { value } = evt.target;

    if (value !== this.state.displayPinsFor) {
      this.setState({ displayPinsFor: value });
    }
  };

  renderSwitchTitle = () => (
    <OptionTypeSwitcher
      translate={this.props.translate('companyPage')}
      title={this.props.translate('companyPage', 'propertiesMap').toString()}
      activeOption={this.state.displayPinsFor}
      hasPropertiesForSale={this.state.hasPropertiesForSale}
      hasPropertiesForRent={this.state.hasPropertiesForRent}
      handleSelectOption={this.handleSelectOption}
    />
  );

  renderStaticMap = () => (
    <StaticCompanyMap
      translate={this.props.translate}
      locale={this.props.locale}
      isMobile={this.props.isMobile}
      pinsType={this.state.displayPinsFor}
      groupedProperties={this.groupPins()}
      switchToDynamicMap={this.switchToDynamicMap}
    />
  );

  renderDynamicMap = () => (
    <DynamicCompanyMap
      translate={this.props.translate}
      locale={this.props.locale}
      isMobile={this.props.isMobile}
      pinsType={this.state.displayPinsFor}
      groupedProperties={this.groupPins()}
      propertiesIdsMap={this.getPropertiesIdsMap()}
      reviewedPins={this.props.reviewedPins}
      setPinAsReviewed={this.props.setPinAsReviewed}
      openDetails={this.props.openDetails}
      isRtl={this.props.isRtl}
      overrideCurrency={this.props.overrideCurrency}
    />
  );

  render() {
    return (
      <div className={styles.companyMap}>
        {this.renderSwitchTitle()}
        {this.state.isDynamicMap ? this.renderDynamicMap() : this.renderStaticMap()}
      </div>
    );
  }
}

CompanyMap.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  forSale: PropTypes.array,
  forRent: PropTypes.array,
  reviewedPins: PropTypes.array,
  setPinAsReviewed: PropTypes.func,
  openDetails: PropTypes.func,
  overrideCurrency: PropTypes.string
};

export default CompanyMap;
